<div class="login__left">
    <img class="login__logo" width="37" height="24" ngSrc="assets/img/SVG/mine-os-logo.svg" alt="Mine logo">

    <div class="login__subtitle-wrapper">
        <h1 class="mine-title-xl login__subtitle">
            {{'authentication.loginSubTitle' | content}}
        </h1>
        
    </div>

    <p class="login__explanation-v2">{{'authentication.loginExplanationV2' | content}}</p>

    <div class="login__btns-container">
        <mine-provider-button [provider]="AuthProviders.google" class="login__btn" (click)="onLoginButtonClick(AuthProviders.google)"></mine-provider-button>

        <mine-provider-button [provider]="AuthProviders.microsoft" class="login__btn login__microsoft login__btn" (click)="onLoginButtonClick(AuthProviders.microsoft)"></mine-provider-button>

        <mine-provider-button class="login__btn" [provider]="AuthProviders.auth0" (click)="onLoginButtonClick(AuthProviders.auth0)"></mine-provider-button>

        <mine-provider-button *ngIf="ssoFlag" class="login__btn" [provider]="AuthProviders.sso" (click)="onLoginButtonClick(AuthProviders.sso)"></mine-provider-button>
    </div>

    <p class="login__disclaimer">
        {{'authentication.loginDisclaimer2' | content}}
        <a class="login__disclaimer-link" href="{{privacyPolicy}}">{{'common.privacyPolicy' | content}}</a> &
        <a class="login__disclaimer-link" href="{{termsOfService}}">{{'common.termOfUse' | content}}</a>.
    </p>

    <div class="login__switch-tenant">
        {{'authentication.currentTenant' | content: {params: {tenant: tenantCtrl.value.value} } }}

        <button mine-button color="tertiary" (click)="switchTenant()" class="login__switch-tenant-link-v2"
        >{{'authentication.switchTenant' | content: {params: {tenant: tenantToSwitch.value} } }}</button>
    </div>

</div>


<div class="login__testimony-container">

    <div class="login__testimony-box">
        <img class="login__logo-sprinkles login__logo-sprinkles--up" width="49" height="60" ngSrc="{{assetsUrl}}/Portal/glitter.png">
        <img class="login__testimony-pic" width="76" height="76" [ngSrc]="'authentication.loginTestimonyPic' | content">
        <p>
            {{'authentication.loginTestimonyText'| content}}
            <span class="login__testimony-separator"></span>
        </p>
        <p class="login__testimony-role" [innerHTML]="'authentication.loginTestimonyRoleText' | content | safe">
        </p>
        <img class="login__logo-sprinkles login__logo-sprinkles--down" width="49" height="60" ngSrc="{{assetsUrl}}/Portal/glitter.png">
    </div>
</div>